import { render, staticRenderFns } from "./DecidedPostDocs.vue?vue&type=template&id=1b08cf00&scoped=true&"
import script from "./DecidedPostDocs.vue?vue&type=script&lang=js&"
export * from "./DecidedPostDocs.vue?vue&type=script&lang=js&"
import style0 from "./DecidedPostDocs.vue?vue&type=style&index=0&id=1b08cf00&prod&lang=css&"
import style1 from "./DecidedPostDocs.vue?vue&type=style&index=1&id=1b08cf00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b08cf00",
  null
  
)

export default component.exports